<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<div class="p-c"><span>Jarrett, Jonathan and Jordan are</span></div>
<div class="illustype_image_text"><div class="image_text"><img alt="9781459251915_i0001.jpg" src="9781459251915_i0001.jpg"/></div></div>
<div class="p-c"><span>Some men are <em class="i">meant</em> to marry!</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-c"><span>Meet three brothers: Jarrett is the eldest—Hunter by name, hunter by nature. Jonathan’s in the middle and a real charmer; there’s never been a woman whom he wanted and couldn’t have. Jordan is the youngest and he’s devilishly attractive. But he’s determined never to succumb to emotional commitment.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-c"><span>These bachelor brothers appear to have it all—looks, wealth, power.... But what about love? That’s where Abbie, Gaye and Stazy come in. As Jarrett, Jonathan and Jordan are about to discover—wanting a woman is one thing, winning her heart is quite another....</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-c"><span>Look out for Jonathan’s story next month!</span></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781459251915_fm02.vue?a0d90b22